import { Playground } from 'playground/Playground'
import { GlobalStyle } from 'styles/global'

const App = () => {
  return (
    <div className="App">
      <GlobalStyle background="" />
      <Playground />
    </div>
  )
}

export default App
